import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const DisconnetWalletIcon = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_690_1546)">
        <path
          d="M15.8332 5.83335V2.83553C15.8332 2.26311 15.2693 1.86112 14.7282 2.04772L8.41851 4.25202M15.8332 5.83335C16.7536 5.83335 17.4998 6.57955 17.4998 7.50002V13.3334M15.8332 5.83335H9.99984M3.71466 5.89533C3.01373 6.09229 2.49984 6.73614 2.49984 7.50002V15.8334C2.49984 16.7538 3.24603 17.5 4.1665 17.5H15.8332C16.2934 17.5 16.7101 17.3135 17.0117 17.0119M3.71466 5.89533C3.85835 5.85495 4.00991 5.83335 4.1665 5.83335H5.83317M3.71466 5.89533L3.5207 5.96309M3.71466 5.89533L5.33061 5.33079M1.6665 1.66669L5.33061 5.33079M5.33061 5.33079L5.83317 5.83335M5.83317 5.83335L17.0117 17.0119M17.0117 17.0119L18.3332 18.3334"
          stroke={COLORS[color]}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_690_1546">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DisconnetWalletIcon;
